module.exports = __webpack_public_path__ + "f968f9f9f4605a0dd647a44b8a8ebb06.pdf";